import DefaultLayout from '##/Default';
import List from './List';


const routes = [
    {
        path: '/reports-version',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Reports-Version'
    }
];

export default routes;
